import '../css/Events.css';

export default function EventItem({ e }) {
    const location = formatLocation(e.location);

    return(
        <div className="event-item-container">
            <div className="event-date-pill" aria-label={`${formatDate(e.startDate)} to ${formatDate(e.endDate)}`}>
                <span className="event-date-month">{formatMonth(e.startDate)}</span>
                <span className="event-date-day">{formatDayRange(e.startDate, e.endDate)}</span>
            </div>
            <div className="event-item-text">
                <span className="event-subtext">{formatDate(e.startDate)} - {formatDate(e.endDate)}</span>
                <br />
                <span className="event-name">{e.name}</span>
                <br />
                {location && <><span className="event-subtext">{location}</span><br /></>}
                <a className="event-lesson-link" href={`/lessons?event=${encodeURIComponent(e.id)}`} aria-label={`Request a lesson at ${e.name}`}>Request a lesson</a>
            </div>
            {e.url && (
                <div className="learn-more-button">
                    <a
                        href={e.url}
                        target="_blank"
                        rel="noopener noreferrer"
                        aria-label={`Learn more about ${e.name}`}
                    >
                        Learn More
                    </a>
                </div>
            )}
        </div>
    );
}

function formatLocation(location) {
    if (typeof location === 'string') return location;
    if (!location) return '';
    return [location.city, location.state, location.country].filter(Boolean).join(', ');
}

// Function to format date without weekdays
function formatDate(dateString) {
    const options = { month: 'long', day: 'numeric', timeZone: 'UTC' };
    return new Date(dateString).toLocaleDateString(undefined, options);
}

function formatMonth(dateString) {
    const options = { month: 'short', timeZone: 'UTC' };
    return new Date(dateString).toLocaleDateString(undefined, options).toUpperCase();
}

function formatDayRange(startDate, endDate) {
    const start = new Date(startDate);
    const end = new Date(endDate);
    const startDay = start.toLocaleDateString(undefined, { day: 'numeric', timeZone: 'UTC' });
    const endDay = end.toLocaleDateString(undefined, { day: 'numeric', timeZone: 'UTC' });

    if (startDay === endDay && start.getUTCMonth() === end.getUTCMonth() && start.getUTCFullYear() === end.getUTCFullYear()) {
        return startDay;
    }

    if (start.getUTCMonth() === end.getUTCMonth() && start.getUTCFullYear() === end.getUTCFullYear()) {
        return `${startDay}–${endDay}`;
    }

    const endMonth = end.toLocaleDateString(undefined, { month: 'short', timeZone: 'UTC' }).toUpperCase();
    return `${startDay}–${endMonth} ${endDay}`;
}
